import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { LangProvider } from "@/i18n";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { FloatingCTA } from "@/components/layout/FloatingCTA";
import { CookieConsent } from "@/components/layout/CookieConsent";
import Home from "@/pages/Home";
import Portfolio from "@/pages/Portfolio";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";

const TITLES = {
  "/": "VOLTPDR — Instalații Electrice, Automatizări & Smart Home",
  "/portofoliu": "Portofoliu — VOLTPDR",
  "/despre": "Despre noi — VOLTPDR",
  "/contact": "Contact — VOLTPDR",
  "/termeni": "Termeni și condiții — VOLTPDR",
  "/cookies": "Politica de Cookies — VOLTPDR",
};

const DESCRIPTIONS = {
  "/": "VOLT PDR SRL — instalații electrice, automatizări industriale, smart home, CCTV și mentenanță. Engineering premium în Suceava și în toată țara.",
  "/portofoliu": "Proiecte VOLTPDR realizate cu precizie: rezidențial, comercial, industrial, smart home și automatizări în România, Italia și Germania.",
  "/despre": "Povestea VOLTPDR: engineering electric cu disciplină, materiale certificate și tehnologie modernă. Servicii complete și certificări.",
  "/contact": "Contact VOLTPDR — telefon, email, adresă și consultanță gratuită pentru proiectul tău electric sau de automatizare.",
  "/termeni": "Termeni și condiții de utilizare a site-ului VOLT PDR SRL.",
  "/cookies": "Politica de cookies a site-ului VOLT PDR SRL.",
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    document.title = TITLES[pathname] || "VOLTPDR — Electric Technology";
    const desc = DESCRIPTIONS[pathname];
    if (desc) {
      let tag = document.querySelector('meta[name="description"]');
      if (tag) tag.setAttribute("content", desc);
    }
  }, [pathname, lenis]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <ReactLenis root ref={lenisRef} options={{ lerp: 0.12, wheelMultiplier: 1.05, smoothWheel: true }}>
      <div className="App min-h-screen bg-ink text-white">
        <BrowserRouter>
          <LangProvider>
            <ScrollToTop />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/portofoliu" element={<Portfolio />} />
                <Route path="/despre" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/termeni" element={<Terms />} />
                <Route path="/cookies" element={<Cookies />} />
              </Routes>
            </main>
            <Footer />
            <FloatingCTA />
            <CookieConsent />
          </LangProvider>
        </BrowserRouter>
      </div>
    </ReactLenis>
  );
}

export default App;
